// 📁 Imports
import { inputValidator } from "@/utils/input-validator.js";

// 💾 Variables

// 📐 Functions
const formValidator = (formIdentificator) => {
  const formValidate = document.querySelector(
    `[data-form=${formIdentificator}]`,
  );
  const validateInputs = formValidate.querySelectorAll("[data-validate]");
  let formIsValid = false;

  Array.from(validateInputs).forEach((input) => {
    const inputTypeValid = input.dataset;
    // console.log(inputValidator(input, inputTypeValid).errors);
    if (inputValidator(input, inputTypeValid).errors.length === 0) {
      formIsValid = true;
    } else {
      formIsValid = false;
    }
  });
  return { isValid: formIsValid, el: formValidate };
};

// 🖱️ Event listener

export { formValidator };
